import {
  BadgePercent,
  Banknote,
  Building2,
  Calculator,
  Landmark,
  Lock,
  ReceiptText,
  Scale,
  ShieldCheck,
  ShoppingCart,
  type LucideIcon,
} from 'lucide-react';

/**
 * Como se enseña cada rol: su nombre en claro, su icono y su color.
 *
 * El `nombre` que guarda la base es un identificador --`facturacion`, `tributario`-- y se
 * usa tal cual en la API y en los permisos, asi que no se toca. Lo que se enseña es otra
 * cosa: el area, escrita como la llamaria alguien de EPAGAL.
 *
 * Los roles los crea EPAGAL, asi que esto no puede ser una lista cerrada: lo que no este
 * aqui sale con su propio nombre en mayuscula inicial y el escudo de siempre.
 *
 * Los iconos dibujan lo que hace el rol, no como se llama: la cajera recibe dinero,
 * catastro mantiene predios, generadores pesa, el tributario compra.
 */
const EN_PANTALLA: Record<string, { titulo: string; icono: LucideIcon; color: string }> = {
  admin: {
    titulo: 'Administración del sistema',
    icono: Lock,
    color: 'bg-amber-100 text-amber-600',
  },
  cajero: {
    titulo: 'Recaudación en ventanilla',
    icono: Banknote,
    color: 'bg-emerald-100 text-emerald-600',
  },
  catastro: {
    titulo: 'Catastro de predios',
    icono: Building2,
    color: 'bg-sky-100 text-sky-600',
  },
  contador: {
    titulo: 'Contabilidad',
    icono: Calculator,
    color: 'bg-slate-200 text-slate-600',
  },
  facturacion: {
    titulo: 'Facturación',
    icono: ReceiptText,
    color: 'bg-indigo-100 text-indigo-600',
  },
  financiero: {
    titulo: 'Área financiera',
    icono: BadgePercent,
    color: 'bg-rose-100 text-rose-600',
  },
  generadores: {
    titulo: 'Generadores especiales',
    icono: Scale,
    color: 'bg-orange-100 text-orange-600',
  },
  tesorero: {
    titulo: 'Tesorería',
    icono: Landmark,
    color: 'bg-teal-100 text-teal-600',
  },
  tributario: {
    titulo: 'Compras y retenciones',
    icono: ShoppingCart,
    color: 'bg-fuchsia-100 text-fuchsia-600',
  },
};

const POR_OMISION = { icono: ShieldCheck, color: 'bg-violet-100 text-violet-600' };

export function insigniaDeRol(nombre: string): { icono: LucideIcon; color: string } {
  const conocido = EN_PANTALLA[nombre.toLowerCase()];
  return conocido ? { icono: conocido.icono, color: conocido.color } : POR_OMISION;
}

/** El nombre del rol tal como se enseña. Un rol nuevo sale con el suyo, en mayuscula inicial. */
export function tituloDeRol(nombre: string): string {
  return EN_PANTALLA[nombre.toLowerCase()]?.titulo ?? nombre.charAt(0).toUpperCase() + nombre.slice(1);
}
